import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';

const TOKEN_HEADER = 'x-access-token'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {


  constructor(
    private _userS: UserService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //console.log(request)
    //console.log(this._userS.getToken)
    if (this._userS.getToken) {
      request = request.clone({
        headers: request.headers.set(TOKEN_HEADER, this._userS.getToken),
      })
    }

    return next.handle(request)
  }
}

export const AuthIntercepterProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true
}
